<tcc-mono-dialog-layout
  [title]="selection?.id ? 'Bewerk selectie' : 'Nieuwe selectie'"
  (onSave)="save()"
>
  <form [formGroup]="form">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-input
            mode="md"
            formControlName="remark"
            labelPlacement="stacked"
            fill="solid"
          >
            <ion-text slot="label" class="form-label"> Naam / opmerking </ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="12">
          <ion-item
            lines="none"
            [detail]="false"
            button
            (click)="editStable('source')"
            class="picker-layout"
          >
            <ion-label position="stacked" class="form-label required">
              Stal oorsprong
            </ion-label>
            <ion-text color="primary" class="ion-margin-horizontal">
              <p>
                {{ getStableName('source') }}
              </p>
            </ion-text>
          </ion-item>
        </ion-col>
        <ion-col size="12">
          <ion-text class="form-label">Geboortedatum-range (van – tot)</ion-text>
        </ion-col>
        <ion-col size="6">
          <ion-input
            mode="md"
            type="date"
            formControlName="min_birth_date"
            labelPlacement="stacked"
            fill="solid"
          >
            <ion-text slot="label" class="form-label"> Van </ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="6">
          <ion-input
            mode="md"
            type="date"
            formControlName="max_birth_date"
            labelPlacement="stacked"
            fill="solid"
          >
            <ion-text slot="label" class="form-label"> Tot </ion-text>
          </ion-input>
        </ion-col>
        <ng-container *ngIf="ageRangeHints(form.get('min_birth_date')?.value, form.get('max_birth_date')?.value) as selectionHints">
          <ion-col size="12" *ngIf="selectionHints.length">
            <ion-note *ngFor="let hint of selectionHints" class="age-hint">{{ hint }}</ion-note>
          </ion-col>
        </ng-container>
        <ion-col size="12" *ngIf="selection?.id">
          <ion-item lines="none" class="ion-no-padding">
            <ion-label class="form-label">Bron dieren</ion-label>
            <ion-select
              formControlName="source"
              interface="popover"
              slot="end"
              (ionChange)="onSourceChange()"
            >
              <ion-select-option *ngFor="let opt of sourceOptions" [value]="opt.value">
                {{ opt.label }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col size="12" *ngIf="form.get('source')?.value === 'excel' && selection?.id">
          <div class="excel-upload-block">
            <ion-text color="medium"><strong>Excel dieren</strong></ion-text>
            <p class="excel-upload-hint">Een nieuwe upload vervangt de bestaande dierlijst.</p>
            <input
              #excelFileInput
              type="file"
              accept=".xlsx,.xls"
              (change)="onExcelFileSelected($event)"
              style="display: none"
            />
            <ion-button size="small" fill="outline" (click)="excelFileInput.click()">
              <fa-icon slot="start" [icon]="['fal', 'file-excel']"></fa-icon>
              Excel uploaden
            </ion-button>
            <ion-button size="small" fill="outline" (click)="downloadExcelTemplate()">
              <fa-icon slot="start" [icon]="['fal', 'file-download']"></fa-icon>
              Download template
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12">
          <div class="filter-colors-block">
            <div class="filter-colors-header">
              <span class="filter-colors-title">Kleuren</span>
              <span class="filter-colors-subtitle">Aan/uit en geboortedatum-range per kleur</span>
            </div>
            <div class="filter-colors-table" formArrayName="filter_colors">
              <div class="filter-colors-table-head">
                <span class="col-kleur">Kleur</span>
                <span class="col-aan">Aan</span>
                <span class="col-van">Van</span>
                <span class="col-tot">Tot</span>
              </div>
              <div
                *ngFor="let ctrl of filterColors.controls; index as i"
                [formGroupName]="i"
                class="filter-color-row-wrap"
              >
                <div class="filter-color-row">
                  <div class="col-kleur">
                    <span
                      class="filter-color-dot"
                      [style.background-color]="getMarkColorHex(ctrl.get('color_name')?.value)"
                    ></span>
                    <span class="filter-color-name">{{ getFilterColorName(i) }}</span>
                  </div>
                  <div class="col-aan">
                    <ion-toggle formControlName="used" mode="md"></ion-toggle>
                  </div>
                  <div class="col-van">
                    <ion-input
                      mode="md"
                      type="date"
                      formControlName="min_birth_date"
                      fill="solid"
                      [disabled]="!(ctrl.get('used')?.value)"
                    ></ion-input>
                  </div>
                  <div class="col-tot">
                    <ion-input
                      mode="md"
                      type="date"
                      formControlName="max_birth_date"
                      fill="solid"
                      [disabled]="!(ctrl.get('used')?.value)"
                    ></ion-input>
                  </div>
                </div>
                <ng-container *ngIf="ageRangeHints(ctrl.get('min_birth_date')?.value, ctrl.get('max_birth_date')?.value) as rowHints">
                  <div class="row-age-hints" *ngIf="rowHints.length">
                    <ion-note *ngFor="let hint of rowHints" class="age-hint row-age-hint">
                      {{ hint }}
                    </ion-note>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</tcc-mono-dialog-layout>
